const decrypt = async (encrypted, iv, key, algorithm = 'AES-GCM') =>
  crypto.subtle.decrypt({ name: algorithm, iv }, key, encrypted);

export default decrypt;
